import { render, staticRenderFns } from "./OccupationPlate.vue?vue&type=template&id=0b8d0615&"
import script from "./OccupationPlate.vue?vue&type=script&lang=js&"
export * from "./OccupationPlate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports